const { registerBlockType } = wp.blocks;

import metadata from "./../../../blocks/3d-viewer/block.json";
import "./style.scss";
// import { v1 } from "./deprecated";
import Edit from "./Edit";
// import Save from "./Save";

registerBlockType(metadata, {
  edit: Edit,
  // edit: () => <h3>Nothing to hide</h3>,
  save: () => null,
  // save: Save,
  // deprecated: [v1],
});
